import React, { FC } from 'react';

import { IconProps } from 'types/components';

import CardIcon from './CardIcon';

const MastercardCard: FC<IconProps> = (props) => (
  <CardIcon {...props}>
    <rect width="208" height="134" x="1" y="1" fill="#ffefe5" rx="24" />
    <path fill="#d6dce5" d="M185 136H25a25 25 0 0 1-25-25V25A25 25 0 0 1 25 0h160a25 25 0 0 1 25 25v86a25 25 0 0 1-25 25ZM25 1A24 24 0 0 0 1 25v86a24 24 0 0 0 24 24h160a24 24 0 0 0 24-24V25a24 24 0 0 0-24-24Z" />
    <path fill="#ff5f00" d="M119.94 41.48H89.32v55h30.62Z" />
    <path fill="#eb001b" d="M91.26 69a34.94 34.94 0 0 1 13.37-27.52 35 35 0 1 0 0 55A34.94 34.94 0 0 1 91.26 69Z" />
    <path fill="#f79e1b" d="M161.26 69a35 35 0 0 1-56.63 27.52 35 35 0 0 0 0-55A35 35 0 0 1 161.26 69Zm-3.34 21.69v-1.13h.45v-.23h-1.16v.23h.46v1.13Zm2.24 0v-1.36h-.35l-.41.93-.41-.93h-.35v1.36h.25v-1l.38.89h.26l.38-.89v1Z" />
  </CardIcon>
);

export default MastercardCard;
